import { type ReactNode } from "react";
import { DbProvider } from "../db";
import { LocationProvider } from "./location";
import LocationSubmitter from "./location-submitter";
import { LocationsProvider } from "./locations";
import SessionHeartbeat from "./session-heartbeat";

export function DataProvider({ children }: { children: ReactNode }) {
  return (
    <DbProvider>
      <LocationProvider />
      <LocationSubmitter />
      <LocationsProvider />
      <SessionHeartbeat />
      {children}
    </DbProvider>
  );
}
